<template>
  <article
    :key="video.pk"
    class="mx-auto flex flex-col my-12 w-full max-w-sm border rounded-lg transition-all duration-300 sm:w-96 sm:max-w-none md:mx-3"
    :class="{ video: video.available }"
  >
    <div class="h-full relative">
      <VideoFavorite v-if="userIsAuthenticated" :video="video" />

      <div v-if="userIsAuthenticated" class="flex h-full">
        <router-link
          v-if="video.content_type === 'video'"
          :to="{ name: 'Video', params: { slug: video.slug } }"
          class="h-full"
        >
          <VideoListItemContent :video="video" />
        </router-link>

        <div
          v-else-if="video.content_type === 'documento'"
          @click="interaction(video.document)"
        >
          <VideoListItemContent :video="video" />
        </div>

        <div
          v-else-if="video.content_type === 'enlace-externo'"
          @click="interaction(video.external_url)"
        >
          <VideoListItemContent :video="video" />
        </div>
      </div>

      <VideoListItemContent v-else class="video" :video="video" />
    </div>

    <!--    <VideoListItemContent v-else :video="video" />-->
  </article>
</template>

<script>
import { mapGetters } from 'vuex'
import VideoListItemContent from '@/components/VideoListItemContent'
import VideoFavorite from '@/components/VideoListItemContentFavorite'

export default {
  components: { VideoListItemContent, VideoFavorite },

  props: {
    video: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters('auth', ['userIsAuthenticated']),
  },

  methods: {
    interaction(content) {
      const payload = {
        content: this.video.pk,
      }
      this.$store.dispatch('videos/sendInteractionData', payload).then(() => {
        window.open(content, '_blank')
      })
    },
  },
}
</script>

<style scoped>
.video:hover {
  @apply cursor-pointer;
  box-shadow: 0 6px 10px 4px rgba(60, 64, 67, 0.15);
}
</style>
